import { useContext, useEffect, useState } from "react";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";
import { 
    CustomContainer, ScreenTitle, FlexRow, Circle, AppSpan, 
    AbsoluteContainer, GridContainer, FlexColumn
} from "src/style";
import { IoIosCheckmark } from "react-icons/io";
import { ICustomerCreationStages } from "src/model";

export const NewCustomerLayout: React.FC<any> = ({currentScreen, children}) => {
    const {info: {customerCreationProcess}} = useContext(AppInfoContext)
    const [process, setProcess] = useState<ICustomerCreationStages>(customerCreationProcess)

    useEffect(() => {
        setProcess(customerCreationProcess)
    }, [customerCreationProcess])

    return (
        <FlexRow 
            alignItems="flex-start" padding='3'
            topPadding="4" height="100" hUnit="%"
        >
            {/* <FixedContainer 
                top="7.5" left="30"
                className="new-user-process-flow-wrapper"
            > */}
                <CustomContainer 
                    width="35"
                    height="90" hUnit="%"
                    className='new-user-process-flow'
                >
                    <ScreenTitle 
                        textSize="2" color="#111111" 
                        fontWeight="600" bottomMargin="4"
                    >
                        Add New Customer
                    </ScreenTitle>
                    <CustomContainer>
                        <FlexRow gap="1.5" bottomMargin='0.5'>
                            <Circle 
                                size="2.4" 
                                borderColor={process?.basicDetails ? '#27AE60' : currentScreen === 'basic-details' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.basicDetails ? '#27AE60' : 'transparent'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.basicDetails ? '#ffffff' : currentScreen === 'basic-details' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'basic-details' && !process?.basicDetails) ? '#111111' : '#ABABAB'}
                            >
                                Basic Details
                            </AppSpan>
                        </FlexRow>
                        <CustomContainer 
                            height="3.6" 
                            width="0.05" 
                            leftMargin="1.3"
                            bgColor="#ABABAB" 
                            bottomMargin='0.5'
                        />
                        <FlexRow gap="1.5">
                            <Circle 
                                size="2.4" 
                                borderColor={process?.locationDetails ? '#27AE60' : currentScreen === 'location-details' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.locationDetails ? '#27AE60' : 'transparent'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.locationDetails ? '#ffffff' : currentScreen === 'location-details' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'location-details' && !process?.locationDetails) ? '#111111' : '#ABABAB'}
                            >
                                Location Details
                            </AppSpan>
                        </FlexRow>
                        <CustomContainer 
                            height="3.6" 
                            width="0.05" 
                            leftMargin="1.3"
                            bgColor="#ABABAB" 
                            bottomMargin='0.5'
                        />
                    </CustomContainer>
                </CustomContainer>
            {/* </FixedContainer> */}

            <CustomContainer
                leftMargin="5"
                rightMargin="5"
                width="49.9"
                className="new-user-content"
            >
                <CustomContainer
                    bottomMargin='3'
                    className='new-user-process-flow-mobile'
                >
                    <ScreenTitle 
                        textSize="2" color="#111111" 
                        fontWeight="600" bottomMargin="4"
                    >
                        Add New Customer
                    </ScreenTitle>
                    <FlexRow alignItems='flex-start' justifyContent='space-between'>
                        <AbsoluteContainer 
                            width='100' sizeUnit='%' top='1.2' zIndex='1'
                        >
                            <GridContainer>
                                <CustomContainer 
                                    height="0.05"
                                    bgColor="#ABABAB" 
                                    width='82' sizeUnit='%'
                                />
                            </GridContainer>
                        </AbsoluteContainer>
                        <FlexColumn 
                            width='auto' sizeUnit='' 
                            justifyContent='center'
                            style={{zIndex: '2'}}
                        >
                            <Circle 
                                size="2.4" bottomMargin='1'
                                borderColor={process?.basicDetails ? '#27AE60' : currentScreen === 'basic-details' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.basicDetails ? '#27AE60' : '#ffffff'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.basicDetails ? '#ffffff' : currentScreen === 'basic-details' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'basic-details' && !process?.basicDetails) ? '#111111' : '#ABABAB'}
                            >
                                Basic Details
                            </AppSpan>
                        </FlexColumn>
                        <FlexColumn 
                            width='auto' sizeUnit='' 
                            justifyContent='center'
                            style={{zIndex: '2'}}
                        >
                            <Circle 
                                size="2.4" bottomMargin='1'
                                borderColor={process?.locationDetails ? '#27AE60' : currentScreen === 'location-details' ? "#1D1D1D" : '#ABABAB'}
                                bgColor={process?.locationDetails ? '#27AE60' : '#ffffff'}
                            >
                                <IoIosCheckmark 
                                    fontSize='1.8rem' 
                                    color={process?.locationDetails ? '#ffffff' : currentScreen === 'location-details' ? "#1D1D1D" : '#ABABAB'}
                                />
                            </Circle>
                            <AppSpan 
                                textSize="1.6" 
                                color={(currentScreen === 'location-details' && !process?.locationDetails) ? '#111111' : '#ABABAB'}
                            >
                                Location
                            </AppSpan>
                        </FlexColumn>
                    </FlexRow>
                </CustomContainer>

                {children}
            </CustomContainer>
        </FlexRow>
    )
}